let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3R5lB")).then(() => parcelRequire('keIpy'));